import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { CompanyActionContext } from '../../../common/types/CompanyActionContext';
import { CreateCompanyStep } from '../types/CreateCompanyStep';

export const templateCreateCompanyPanel = document.createElement('template');

templateCreateCompanyPanel.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='content-wrapper'>
      <gz-wizard class='company-create-wizard'></gz-wizard>

      <div class='form-wrapper'>
        <!-- Company Details Form -->
        <section id='company-details-form-wrapper'>
          <gz-company-details-form context='${CompanyActionContext.Create}'></gz-company-details-form>
        </section>

        <!-- Company Authentication Form -->
        <section id='company-authentication-form-wrapper' class='hidden'>
          <gz-company-authentication-form context='${CompanyActionContext.Create}'></gz-company-authentication-form>
        </section>

        <!-- Company Add License Form -->
        <section id='company-add-license-form-wrapper' class='hidden'>
          <gz-license-main-form context='${CompanyActionContext.Create}'></gz-license-main-form>
          <gz-custom-fields-form class='hidden'></gz-custom-fields-form>
        </section>
      </div>

      <div class='bottom-buttons'>
        <gz-button id='next-button' data-step='${CreateCompanyStep.Authentication.toString()}' disabled></gz-button>
        <gz-button id='back-button' type='outline' color='secondary' class='hidden'></gz-button>
        <div class='flex-auto'></div>
        <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
      </div>
    </div>
  </div>
`;
